var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"py-2"},[_c('textFieldForm',{attrs:{"valueInput":_vm.values.name,"rule":[..._vm.rules.required],"label":"Descripción","errorMessages":_vm.serverErrors.name},on:{"valueChange":(v) => {_vm.values.name = v; delete _vm.serverErrors.name}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }